const MAX_IMAGE_PIXELS = 64000000;

export const checkImagePixelLimit = (file) => new Promise((resolve) => {
    const objectUrl = URL.createObjectURL(file);
    const image = new Image();
    const finish = (result) => {
        URL.revokeObjectURL(objectUrl);
        resolve(result);
    };
    image.onload = () => {
        const pixels = image.naturalWidth * image.naturalHeight;
        if (pixels > MAX_IMAGE_PIXELS) {
            return finish({
                ok: false,
                reason: `图片分辨率为${image.naturalWidth}×${image.naturalHeight}，超过6400万像素限制`,
            });
        }
        finish({ ok: true });
    };
    image.onerror = () => finish({ ok: false, reason: '无法读取图片尺寸' });
    image.src = objectUrl;
});
